import { Permissions } from '@lanterds/types';
import { baseUrl, genericNetworkErrorHandler } from '.';
import { AuthRequest, Method } from 'src/util/Request';
import { NewFmtpCustomer } from 'src/components/Views/AdminView/Customers/types';

export const getCustomersByPermission = async (permission: Permissions) => {
    const res = await AuthRequest(`${baseUrl}/customers/${permission}`, Method.GET);

    if (res.ok) {
        const customers = await res.json();
        return customers;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const getCustomers = async () => {
    const res = await AuthRequest(`${baseUrl}/admin/customers`, Method.GET);

    if (res.ok) {
        const customers = await res.json();
        return customers.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};

export const editCustomer = async (customerInfo: NewFmtpCustomer, createNew: boolean) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    const res = await AuthRequest(`${baseUrl}/admin/customer`, createNew ? Method.POST : Method.PUT, headers, {
        customer: customerInfo,
    });

    if (res.ok) {
        const customers = await res.json();
        return customers.data;
    } else {
        await genericNetworkErrorHandler(res);
    }
};
